import { useState, useCallback } from 'react'

export const useNotifications = () => {
  const [notifications, setNotifications] = useState([])

  const addNotification = useCallback((eventType, data, customDuration = null) => {
    const notification = {
      id: Date.now() + Math.random(),
      eventType,
      data,
      timestamp: new Date().toISOString()
    }

    setNotifications(prev => [...prev, notification])

    // Duração baseada no tipo de evento ou customizada
    let duration = customDuration || 10000 // 10 segundos mínimo
    
    if (!customDuration) {
      switch (eventType) {
        case 'opportunity_accepted':
          duration = 12000 // 12 segundos para oportunidades aceitas
          break
        case 'new_opportunity':
          duration = 11000 // 11 segundos para novas oportunidades
          break
        case 'project_billed':
          duration = 13000 // 13 segundos para projetos faturados
          break
        case 'ege_energy_milestone':
          duration = 15000 // 15 segundos para EGE Energy
          break
        default:
          duration = 10000 // 10 segundos padrão
      }
    }
    
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== notification.id))
    }, duration)
  }, [])

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }, [])

  const clearAllNotifications = useCallback(() => {
    setNotifications([])
  }, [])

  return {
    notifications,
    addNotification,
    removeNotification,
    clearAllNotifications
  }
}
